import Card from '@mui/joy/Card';
import { SupportInfo } from '../SupportInfo/SupportInfo';

type AuthLayoutProps = {
  children: React.ReactNode;
};

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      style={{
        width: '100%',
        minHeight: 'calc(100vh - 5rem)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Card
        sx={{
          borderRadius: 7,
          padding: '1rem',
          width: '90%',
          maxWidth: '28rem',
          textAlign: 'center',
          border: '1px solid #cccccc',
          marginBottom: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {children}
      </Card>
      <SupportInfo />
    </div>
  );
}
